import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./assets/styles/main.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <div
      id="kt_docs_toast_stack_container"
      className="toast-container position-fixed top-0 end-0 p-3 z-index-9999"
    ></div>
    <App />
  </React.StrictMode>
);
